

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
//require('es6-promise').polyfill();
window.Promise = require('es6-promise-polyfill').Promise;
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let access_token = localStorage.getItem('access_token');
if(access_token){
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
}
/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/* Using dayjs to replace moment */
//window.moment = require('moment-timezone');
window.moment = require('dayjs');
locale_en_gb = require('dayjs/locale/en-gb');
moment.locale(locale_en_gb);
var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone'); // dependent on utc plugin
var relativeTime = require('dayjs/plugin/relativeTime');
var localeData = require('dayjs/plugin/localeData');
var isoWeek = require('dayjs/plugin/isoWeek');
var localizedFormat = require('dayjs/plugin/localizedFormat');
var arraySupport = require('dayjs/plugin/arraySupport');
var badMutable = require('dayjs/plugin/badMutable');
var isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
var duration = require('dayjs/plugin/duration');
moment.extend(utc);
moment.extend(timezone);
moment.extend(relativeTime);
moment.extend(localeData);
moment.extend(isoWeek);
moment.extend(localizedFormat);
moment.extend(arraySupport);
moment.extend(badMutable);
moment.extend(isSameOrBefore);
moment.extend(duration);

/**
 * Raven.js is the official browser JavaScript client for Sentry. It automatically
 * reports uncaught JavaScript exceptions triggered from a browser environment,
 * and provides a rich API for reporting your own errors.
 */
window.Raven = require('raven-js')
window.RavenVue = require('raven-js/plugins/vue')
window.Raven.config(window.Laravel.sentryRaven).addPlugin(window.RavenVue, window.Vue).install();



/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');
window.bus = new Vue();


window.Vue.mixin({
    data: function () {
        return {
            auth_user: window.auth_user,
            is_loading: false,
            csrf_field: window.csrf_field,
            route_name: window.route_name
        }
    },
    computed: {
        is_authenticated: function () {
            return typeof auth_user === 'object';
        },
    },
    filters: {
        toLocaleString: function (number) {
            if (!number) {
                return 0;
            }
            return number.toLocaleString();
        },
        shortenNumber: function (number) {
            if (number == undefined) {
                return '-';
            }
            if (!number) {
                return 0;
            }
            if (number < 10000) {
                return number.toLocaleString();
            }

            var symbols = ["", "k", "M", "B", "T"];

            var tier = Math.log10(number) / 3 | 0;
            if (tier == 0) {
                return number;
            } else if (tier > 4) {
                tier = 4;
            }

            var suffix = symbols[tier];
            var scale = Math.pow(10, tier * 3);
            var scaled = number / scale;

            var toFixed = function (num, fixed) {
                var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
                return num.toString().match(re)[0];
            };
            return toFixed(scaled, 1) + suffix;
        },
        formatCurrency: function (unit_amount) {
            var num = unit_amount / 100; /*convert to dollars*/
            num = num.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
                minimumFractionDigits: 0
            });
            return num;
        }
    },
    methods: {
        ucFirst: function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        textTruncate: function (str, length, ending) {
            if (length == null) {
                length = 100;
            }
            if (ending == null) {
                ending = '...';
            }
            if (str && str.length > length) {
                return str.substring(0, length - ending.length) + ending;
            } else {
                return str;
            }
        },
        formatDate: function (date, format) {
            if (!date) {
                return;
            }
            var timezone = moment.tz.guess();
            return moment.tz(date, 'UTC').tz(timezone).format(format);
        },
        formatDateWithoutTimezone: function (date, format) {
            if (!date) {
                return;
            }
            return moment(date).format(format);
        },
        get: function (object, key_string, default_value) {
            key_string = key_string.replace(/\[(\w+)\]/g, '.$1'); /* convert indexes to properties */
            key_string = key_string.replace(/^\./, '');           /* strip a leading dot */
            var key_array = key_string.split('.');
            for (var i = 0, n = key_array.length; i < n; ++i) {
                var key = key_array[i];
                if (typeof object === 'object' && key in object) {
                    object = object[key];
                } else {
                    return default_value;
                }
            }
            return object;
        },
        showMessage: function (text) {
            if (typeof window.Snackbar === 'object') {
                Snackbar.show({
                    text: text,
                    pos: 'top-center',
                    duration: 6000
                });
            } else {
                alert(text);
            }
        },
        showErrorMessage: function (error, options) {
            var text = 'An error has occurred';
            options = options || {};
            var duration = 6000;
            if (options.duration >= 0) {
                duration = options.duration;
            }
            if (error && error.response && error.response.data) {
                if (error.response.data.error && error.response.data.error.validator_messages) {
                    text = error.response.data.error.validator_messages[0];
                } else if (error.response.data.exception && error.response.data.exception.message) {
                    text = error.response.data.exception.message;
                }
            }
            if (typeof window.Snackbar === 'object') {
                Snackbar.show({
                    text: text,
                    customClass: 'error',
                    pos: 'top-center',
                    duration: duration
                });
            } else {
                alert(text);
            }
        },
        getPercentage: function (number, precision) {
            if (!number) {
                return 0;
            }
            precision = precision || 2;
            return (number * 100).toFixed(2);
        },
        setSort: function (obj, key, dir) {
            var current_sort = obj.order_by;
            if (current_sort === key) {
                /*flip direction*/
                if (obj.order_dir === 'asc') {
                    Vue.set(obj, 'order_dir', 'desc');
                } else {
                    Vue.set(obj, 'order_dir', 'asc');
                }
            } else {
                /*new key, start with asc*/
                Vue.set(obj, 'order_by', key);
                dir = dir || 'desc';
                Vue.set(obj, 'order_dir', dir);
            }

            if (obj.pagination) {
                if (obj.pagination.page) {
                    obj.pagination.page = 1;
                }
                if (obj.pagination.current_page) {
                    obj.pagination.current_page = 1;
                }
            }
            if (obj.sort_callback) {
                obj.sort_callback();
            }
        },
        getRandomString: function (length) {
            length = length || 24;
            var str = '';
            var characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            var characters_length = characters.length;
            for (var i = 0; i < length; i++) {
                str += characters.charAt(Math.floor(Math.random() * characters_length));
            }
            return str;
        },
        initIntersection: function (el, cb) {
            if (!el) {
                return;
            }
            var self = this;
            if (!this.io) {
                this.io = new IntersectionObserver(entries => {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            let target = entry.target;
                            if (!target.__loaded && target.__cb) {
                                target.__cb();
                                target.__loaded = true;
                                self.io.unobserve(target);
                            }
                        }
                    });
                }, {});
            }

            el.__loaded = false;
            el.__cb = cb;
            this.io.observe(el);
        },
        formatTextEntities: function (text) {
            if (!text) {
                return text;
            }

            /*Replace special characters*/
            text = text.replaceAll('&lt;', '<');
            text = text.replaceAll('&gt;', '>');
            text = text.replaceAll('&amp;', '&');

            /*Email*/
            var regex = /([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)/gmi;
            text = text.replaceAll(regex, '<a href="mailto:$1" target="_blank" title="$1">$1</a>');

            /*Add http to urls starting with www*/
            var words = text.split(' ');
            words = words.map(function (word) {
                if (word && word.substring(0, 4) === 'www.') {
                    word = 'http://' + word;
                }
                return word;
            });
            text = words.join(' ');

            /*Urls*/
            regex = /(https?:\/\/((?:\w+.)?\w+\.\w{2,3}[\/\w@\.\-\?&=]*))/gmi;
            text = text.replaceAll(regex, '<a href="$1" target="_blank" title="$2">$2</a>');

            /*Hashtags*/
            regex = /(#(\w+))/gmi;
            text = text.replaceAll(regex, '<a href="/hashtag/$2" title="$1">$1</a>');

            /*Mentions*/
            regex = /\B(@([\w\.]+\b))/gmi;
            text = text.replace(regex, `<a href="/mention/$2" title="$1">$1</a>`);
            return text;
        },
        getSentimentText: function (score) {
            if (typeof score !== 'number') {
                return;
            }
            if (score > 0.5) {
                return 'Very Positive';
            } else if (score > 0.1) {
                return 'Positive';
            } else if (score > -0.1) {
                return 'Neutral';
            } else if (score > -0.5) {
                return 'Negative';
            } else {
                return 'Very Negative';
            }
        },
        fromNow: function (date, without_suffix) {
            if (!date) {
                return;
            }
            var timezone = moment.tz.guess();
            date = moment.tz(date, 'UTC').tz(timezone);
            return date.fromNow(without_suffix);
        },
        scrollTo: function (el) {
            $('html,body').animate({
                scrollTop: $(el).offset().top
            }, 500);
        },
        hexToRGB: function (h) {
            let r = 0, g = 0, b = 0;

            /*3 digits*/
            if (h.length == 4) {
                r = "0x" + h[1] + h[1];
                g = "0x" + h[2] + h[2];
                b = "0x" + h[3] + h[3];

                /*6 digits*/
            } else if (h.length == 7) {
                r = "0x" + h[1] + h[2];
                g = "0x" + h[3] + h[4];
                b = "0x" + h[5] + h[6];
            }
            r = +r;
            g = +g;
            b = +b;
            return `${r},${g},${b}`;
        }
    }
});


// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/vendor.js